export const getOutletDisplayText = (company: DealerIntegration.Components.Schemas.MilesBrokerCompaniesData) => {
  return `${company?.milesBerCode} - ${company?.brand?.name}`;
};
